/**
 * API客户端：直接使用RESTful API
 */
import axios from 'axios'

// API基础地址
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api'

// 创建axios实例
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
})

// 请求拦截器：统一处理请求
apiClient.interceptors.request.use(
  (config) => {
    // 处理 URL：如果 URL 是 /api 或 /api.json，替换为空字符串（因为 baseURL 已经是 /api）
    if (config.url === '/api' || config.url === '/api.json' || config.url.endsWith('/api.json')) {
      config.url = ''
    }
    
    // 添加 Authorization header（从 localStorage 获取 access_token）
    if (typeof localStorage !== 'undefined') {
      const accessToken = localStorage.getItem('access_token')
      if (accessToken) {
        config.headers = config.headers || {}
        config.headers['Authorization'] = `Bearer ${accessToken}`
      }
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理响应
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 统一错误处理
    if (error.response) {
      const { status, data } = error.response
      
      // 处理 401 未授权错误（token 无效或过期）
      if (status === 401) {
        // 检查是否是认证相关的错误
        const isAuthError = data && (
          data.error === 'missing_token' || 
          data.error === 'invalid_token' ||
          data.error_description === 'Missing Authorization header' ||
          data.error_description === 'Invalid or expired access token'
        )
        
        if (isAuthError) {
          // 清除 token 和用户信息
          if (typeof localStorage !== 'undefined') {
            localStorage.removeItem('access_token')
            localStorage.removeItem('user')
            // 延迟跳转，避免在路由守卫执行时清除导致问题
            setTimeout(() => {
              if (typeof window !== 'undefined' && window.location) {
                // 避免重复跳转
                if (window.location.pathname !== '/login') {
                  window.location.href = '/login'
                }
              }
            }, 100)
          }
        }
      }
      
      console.error('API Error:', status, data)
    }
    return Promise.reject(error)
  }
)

export default apiClient

